import wordpressData from 'data';

/**
 * Absolute URL of the public wizard page, from WordPress (`tempcontrolSizingUrl`).
 * Pass `key` to resume a project (`?project=<key>`). Absolute because these
 * links sit outside the my-account SPA router.
 */
export const buildWizardUrl = (key?: string): string => {
  const base = wordpressData?.tempcontrolSizingUrl ?? wordpressData?.siteUrl ?? window.location.origin;
  if (!key) {
    return base;
  }
  const separator = base.includes('?') ? '&' : '?';
  return `${base}${separator}project=${encodeURIComponent(key)}`;
};

/**
 * Absolute URL of the portal's TempControl projects list: the WP `myAccountUrl`
 * root + the SPA's own `/tempcontrol-projects` route. `mineOnly` adds `?ownership=mine`.
 */
export const buildPortalProjectsUrl = ({ mineOnly = false }: { mineOnly?: boolean } = {}): string => {
  const portalRoot = (wordpressData?.myAccountUrl ?? '').replace(/\/$/, '');
  const url = `${portalRoot}/tempcontrol-projects`;
  return mineOnly ? `${url}?ownership=mine` : url;
};
